import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Typography,
    Box,
    Chip
} from '@mui/material';

const BlogCard = ({ post }) => {
    const {
        title,
        slug,
        excerpt,
        coverImage,
        categories
    } = post;

    // 画像エラー時の処理
    const handleImageError = (e) => {
        e.target.src = '/images/blog/default-cover.jpg';
    };

    return (
        <Card
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: 6,
                },
                borderRadius: 2,
                overflow: 'hidden'
            }}
        >
            <CardActionArea
                component={RouterLink}
                to={`/blog/${slug}`}
                sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
            >
                <Box sx={{ height: 200, overflow: 'hidden', position: 'relative' }}>
                    <CardMedia
                        component="img"
                        src={coverImage || '/images/blog/default-cover.jpg'}
                        alt={title}
                        onError={handleImageError}
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </Box>
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ mb: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {categories.map((category, index) => (
                            <Chip
                                key={index}
                                label={category}
                                size="small"
                                sx={{ backgroundColor: 'rgba(25, 118, 210, 0.08)', fontWeight: 500 }}
                            />
                        ))}
                    </Box>
                    <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        sx={{
                            fontWeight: 'bold',
                            fontSize: { xs: '1.1rem', sm: '1.3rem' },
                            lineHeight: 1.3,
                            mb: 1
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            mb: 2,
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            lineHeight: 1.5,
                            flexGrow: 1
                        }}
                    >
                        {excerpt}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default BlogCard; 